module.exports = __webpack_public_path__ + "static/media/icon-cat-SK.0d4bd04c.svg";